import { ShieldCheck, FileCheck2, UserCheck, Clock } from 'lucide-react';

const cards = [
  { icon: Clock,       label: 'Timing',     rotate: '-rotate-[12deg]', y: 'translate-y-3' },
  { icon: FileCheck2,  label: 'Evidence',   rotate: '-rotate-[4deg]',  y: 'translate-y-0' },
  { icon: ShieldCheck, label: 'Governance', rotate: 'rotate-[4deg]',   y: 'translate-y-0' },
  { icon: UserCheck,   label: 'Oversight',  rotate: 'rotate-[12deg]',  y: 'translate-y-3' },
];

/**
 * A fanned stack of glass cards that straightens and spreads on hover.
 */
export function GlassCards() {
  return (
    <div
      className="group relative mx-auto flex items-center justify-center px-6"
      style={{ width: 340, height: 230 }}
    >
      {cards.map(({ icon: Icon, label, rotate, y }) => (
        <div
          key={label}
          className={`relative -mx-5 flex h-40 w-28 flex-shrink-0 flex-col items-center justify-center gap-3 rounded-xl border border-cyan-400/25 bg-gradient-to-b from-cyan-400/15 to-blue-600/5 shadow-[0_20px_40px_rgba(0,0,0,0.35)] backdrop-blur-md transition-all duration-500 ${rotate} ${y} group-hover:mx-1 group-hover:translate-y-0 group-hover:rotate-0`}
        >
          <Icon className="h-8 w-8 text-cyan-300" />
          <span className="flex items-center justify-center px-2 text-center text-cyan-100">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
